import { useSelector } from "react-redux";
import SignInForm from "../SignInForm/SignInForm";
import { useEffect } from "react";

  const SigninScreen = ({ handleOnSubmit, onClose,isMobile,signInPopupDesktop,setdata }: any) => {
  const isShowPopup = useSelector((state: any) => state.scheduler.isShowPopup);
  const getOtpFailure = useSelector((state: any) => state.auth.getOtpFailure);
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);

    return (
      <>
      {
         isMobile && 
            <button className={isShowPopup ? "signIn-close-button-closure" : "signIn-close-button"} onClick={onClose}>
          ×
        </button>
      }
       

        <div className={isMobile ? isShowPopup ? "sign-in-container-closure" : "sign-in-container" : signInPopupDesktop?"sign-in-container-D":"sign-in-container-D-checkout"}>
          <div className={isMobile ? "sign-in-card" : "sign-in-card-D"}>
            {
              (isMobile || signInPopupDesktop) && <h1 className="sign-in-title">Sign In</h1>
            }
            <p className={isMobile ? "sign-in-subtitle" : "sign-in-subtitle-D"}>
              {!signInPopupDesktop ? "Ready to order? " : ""}Sign in with your {restaurantDetails?.platformConfiguration?.sendOtpViaEmail?"email id":"mobile number"} and get started!
            </p>
            <div className={isMobile ? "" : signInPopupDesktop ? "Signin-form-D-popup" : "Signin-form-D"}>
              <SignInForm setdata={setdata} onSubmit={handleOnSubmit} signInPopupDesktop={signInPopupDesktop} onClose={onClose} />

            </div>
          </div>
        </div>
      </>
    );
  };

  export default SigninScreen;